import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'linaria';
const pillStyle = "p1mk9fki";
/**
 * A pill component for rendering things like clickable lists of topics or categories.
 * Pass in an `onClick` callback and handle the click yourself, or pass in an `href`
 * value and the pill will become a link to that url.
 */

export const Pill = ({
  children,
  promoted,
  href,
  className,
  ...remaining
}) => {
  const elementProps = {
    className: cx(pillStyle, className, promoted && 'promoted'),
    href,
    ...remaining
  }; // if an href is passed, element should be an anchor (hyperlink)

  if (href) {
    return <a {...elementProps}>{children}</a>; // if no href, this is a button element
  } else {
    return <button {...elementProps}>{children}</button>;
  }
};
Pill.propTypes = {
  /**
   * Content of the button (e.g. button label)
   */
  children: PropTypes.node.isRequired,
  /**
   * If true, will apply a visual style that differentiates the pill from the others.
   */
  promoted: PropTypes.bool,
  /**
   * Destination url for the button - if provided, will render the button as
   * an anchor styled like a button
   */
  href: PropTypes.string,
  /**
   * CSS class name if styles need to be provided/overridden.
   */
  className: PropTypes.string
};
Pill.defaultProps = {
  promoted: false,
  href: undefined,
  className: null
};

require("./pill.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./pill.js");